//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ServerFilter from '../components/ServerFilter/ServerFilter.vue'
import { EventBus } from '../EventBus/EventBus.js'

export default {
  name: 'SectionWithFilter',
  components: {
    ServerFilter
  },
  props: {
    splitterKey: {
      type: String,
      default: null
    },
    contentWrapped: {
      type: Boolean,
      default: false
    },
    hiddenFilter: {
      type: Boolean,
      default: false
    },
    filterConfig: {
      type: Object, // { filterName, filterType, filterFormId, filterUnavailable }
      default: function () {
        return {}
      }
    }
  },
  data: function () {
    return {
      useInnerFilter: true,
      splitterVerticalModel: this.hiddenFilter ? 100 : 70
    }
  },
  computed: {
    splitterStorageKey: function () {
      if (this.splitterKey) {
        return this.splitterKey + 'SplitterVerticalModel'
      }
      return null
    },
    containerClass: function () {
      const classes = ['section-with-filter']
      if (this.contentWrapped) {
        classes.push('section-with-filter--wrapped')
      }
      return classes
    },
    contentClass: function () {
      const classes = ['section-with-filter_content']
      if (this.contentWrapped) {
        classes.push('shadow-2')
      }
      return classes
    }
  },
  watch: {
    splitterVerticalModel: function (result) {
      if (this.splitterStorageKey && !isNaN(result)) {
        localStorage.setItem(this.splitterStorageKey, result)
      }
    }
  },
  created: function () {
    if (this.splitterStorageKey) {
      const stocksViewSplitterVerticalModel = localStorage.getItem(this.splitterStorageKey)
      if (stocksViewSplitterVerticalModel && !isNaN(stocksViewSplitterVerticalModel)) {
        this.splitterVerticalModel = Number(stocksViewSplitterVerticalModel)
      }
    }

    EventBus.$emit('set-child-filter', {
      filterConfig: this.filterConfig,
      onFilterInstalled: this.onFilterInstalled
    })
  },
  beforeDestroy: function () {
    EventBus.$emit('remove-child-filter', {
      filterConfig: this.filterConfig
    })
  },
  methods: {
    onHideFilter: function () {
      this.splitterVerticalModel = 100
    },
    onDisplayFilter: function () {
      this.splitterVerticalModel = 70
    },

    onFilterInstalled: function () {
      this.useInnerFilter = false
    }
    // onFilterUninstalled: function () {
    //   this.useInnerFilter = true
    // }
  }
}

